import sweetalert2 from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import '../assets/style/swal.scss';

const Swal = withReactContent(sweetalert2);

export function toastSuccess({ text, timer = 3000, type = 'success', position = 'top-end' }) {
  return Swal.fire({
    timer,
    type,
    icon: 'success',
    position,
    html: text,
    toast: true,
    showConfirmButton: false
  });
}

export function toastError({ text, timer = 3000, type = 'error', position = 'top-end' }) {
  return Swal.fire({
    timer,
    type,
    icon: 'error',
    position,
    html: text,
    toast: true,
    showConfirmButton: false
  });
}

export default Swal;